// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateMemoMutationVariables = Types.Exact<{
  input: Types.GenerateMemoInput;
}>;


export type GenerateMemoMutation = { __typename?: 'Mutation', generateMemo: { __typename?: 'WorkflowTracker', id: string } };

export const Operations = {
  Mutation: {
    GenerateMemo: 'GenerateMemo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateMemoDocument = gql`
    mutation GenerateMemo($input: GenerateMemoInput!) {
  generateMemo(input: $input) {
    id
  }
}
    `;
export type GenerateMemoMutationFn = Apollo.MutationFunction<GenerateMemoMutation, GenerateMemoMutationVariables>;

/**
 * __useGenerateMemoMutation__
 *
 * To run a mutation, you first call `useGenerateMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMemoMutation, { data, loading, error }] = useGenerateMemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMemoMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMemoMutation, GenerateMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMemoMutation, GenerateMemoMutationVariables>(GenerateMemoDocument, options);
      }
export type GenerateMemoMutationHookResult = ReturnType<typeof useGenerateMemoMutation>;
export type GenerateMemoMutationResult = Apollo.MutationResult<GenerateMemoMutation>;
export type GenerateMemoMutationOptions = Apollo.BaseMutationOptions<GenerateMemoMutation, GenerateMemoMutationVariables>;